export const CHECK_AUTH = 'checkAuth';
export const CALLBACK = 'callbackLogin';
export const LOGIN = 'login';
export const LOGOUT = 'logout';
export const FETCH_PRODUCTS = 'fetchProducts';
export const FETCH_PRODUCT = 'fetchProduct';
export const FETCH_PRODUCT_CONTENT = 'fetchProductContent';
export const DOWNLOAD_PRODUCT = 'downloadProduct';
